/**
 * Init's items needed for hero abilities videos
 */
(function(window, overwatch){
 	
	var Abilities = {

		init: function() {
	
			var mql;
	
			Abilities.desktopVideo = $(".abilities .ability-video.desktop-video");
			Abilities.videoOverlay = $(".abilities .video-overlay");
			Abilities.mobileVideo = $(".ability-video.mobile-video");
	
			Abilities.videoOverlay.hover(
				function() {
					$(this).siblings("video")[0].play();
				},
				function(e) {
					$(this).siblings("video")[0].pause();
					$(this).siblings("video")[0].load(); //this should be .currentTime = 0 but use this temporarily until solution is found for chrome
				}
			);
	
			Abilities.desktopVideo.on("click", function() {
				if (overwatch.util.ie() !== '8') {
					var currentHero = $(this).data("hero");
					var currentAbility = $(this).data("ability");
					var data = createVideoData(currentHero, currentAbility);
					var videoData = data[0];
					var videoIndex = data[1];
					Lightbox.loadHTML5Video(videoData, videoIndex);
				}
			});
	
			// We don't want to exit full screen on a desktop if a user is trying to full screen
			if (overwatch.util.mobile() === true) {
				// Pause videos if device goes into landscape mode or changes orientation.
				MediaQuery.onDesktop(function() {
					document.exitFullscreen();
					pauseVideos();
				});
			}
	
			function pauseVideos() {
				Abilities.mobileVideo.each(function(i, ele) {
					$(ele).children("video").get(0).pause();
				});
			}
	
		}
	};
	
	function createVideoData(hero, abilityKey) {
	
		var videoIndex = 0;
		var videoData = [];
	
		for(var key in heroAbilities){
			var ability = heroAbilities[key],
				abilityInfo = {};
	
			abilityInfo.title = ability.title;
			abilityInfo.subtitle = ability.subtitle;
			abilityInfo.description = ability.description;
			abilityInfo.sources = [{ type: "video/webm", src: ability.sources.webm}, {type: "video/mp4", src: ability.sources.mp4}];
			abilityInfo.contentClass = "hero-" + hero;
			abilityInfo.autoplay = true;
	
			videoData.push(abilityInfo);
	
			if (abilityKey === key) {
				videoIndex = videoData.length - 1;
			}
		}
	
		return [videoData, videoIndex];
	}

	window.Abilities = Abilities;

}(window, window.overwatch));
